import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../../dynamicFormBuilder/FormField'
import { AdditionalLayout, CommentLayout, UserDefinedLayout } from './Layout';
import {
    Column,
    DataGrid,
    Grouping,
    FilterRow,
    Sorting,
    LoadPanel as GridLoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
import DataSource from 'devextreme/data/data_source';
import { createStore } from 'devextreme-aspnet-data-nojquery';
function KitDetailTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
var accessToken = props.oidc.user.access_token;

    const kitDataSource = new DataSource({
        store: new createStore({
            key: 'KitHeaderRowID',
            loadParams: {
                ItemId: function () {
                    return props.formFields.ItemId??'00000000-0000-0000-0000-000000000000';
                },
                warehouseId: function () {
                    return props.formFields.WarehouseID??'00000000-0000-0000-0000-000000000000';
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/om/SaleOrder/GetKitDetails`,
            onBeforeSend: function (method, ajaxOptions) {
                ajaxOptions.headers = {
                    Authorization: `Bearer ${accessToken}`
                };
            }
        }),
    });
    return (
       <div  style={{marginTop:'12px'}}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={kitDataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    remoteOperations={true}
                    hoverStateEnabled={true}
                    height="100%"
                >
                    <Selection mode="single" />
                    <ColumnHeaderFilter />
                    <Sorting visible={true} mode="multiple" />
                    <GridLoadPanel enabled={true} />
                    <FilterRow visible={true} />
                    <Grouping autoExpandAll={false} />
                    <Column dataField="KittCode" caption="Kit" dataType="string" />
                    <Column dataField="Warehouse" caption="WH" dataType="string" />
                    <Column dataField="ItemCode" caption="Item" dataType="string" />
                    <Column dataField="LotCode" caption="Lot" dataType="string" />
                    <Column dataField="Quantity" caption="Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                </DataGrid>
            </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(KitDetailTab);
